// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import {
    Autocomplete,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Fab,
    FormHelperText,
    IconButton,
    Tab,
    Tooltip,
    Typography,
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'
import Icon from '../icon';
import apiUrl from '../../configs/constant';
import MsiDatagrid from '../custom/MsiDatagridAuto';

import moment from 'moment'
import { useToast } from '../ToastProvider'
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Controller, useForm } from 'react-hook-form';
import appInfo from '../../configs/app-info';
import Swal from 'sweetalert2';

interface Props {
    mmgudangId?: number | string | null;
}

export default function Index({ mmgudangId }: Props) {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();

    // ** State

    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))
    const [tabs, setTabs] = useState<string>('0')
    const [openDialogRack, setOpenDialogRack] = useState<boolean>(false)
    const [openDialogMutasi, setOpenDialogMutasi] = useState<boolean>(false)
    const [isEditRack, setIsEditRack] = useState<boolean>(false)
    const [isEditMutasi, setIsEditMutasi] = useState<boolean>(false)

    const handleChangeTabs = (event: React.SyntheticEvent, newValue: string) => {
        setTabs(newValue);
        if (newValue === '1') {
            getData()
        } else if (newValue === '0') {
            getRack()
        }
    };

    const [listData, setListData] = useState<any[]>([])
    const [listRack, setListRack] = useState<any[]>([])

    const [valRackAsal, setValRackAsal] = useState<any>(null)
    const [valRackTujuan, setValRackTujuan] = useState<any>(null)

    const [valBarang, setValBarang] = useState<any>(null)
    const [listBarang, setListBarang] = useState<any[]>([])

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        getData()
        getRack()
    }, [mmgudangId])

    const navigate = useNavigate();

    interface FormInputs {
        mmgudang_sub_id: number;
        kode: string;
        nama: string;

        keterangan: string;
        mmbarang_id: any;
        mmbarang_batch_id: any
        mmgudang_sub_asal_id: any;
        mmgudang_sub_tujuan_id: any;
        qty: any;
        mmgudang_sub_mutasi_id: any;
    }

    const resetDetail = () => {
        setValue('mmgudang_sub_id', 0)
        setValue('kode', '')
        setValue('nama', '')

        setValue('mmbarang_id', null)
        setValue('mmbarang_batch_id', null)
        setValue('mmgudang_sub_asal_id', null)
        setValue('mmgudang_sub_tujuan_id', null)
        setValue('qty', null)
        setValue('keterangan', '')
        setValue('mmgudang_sub_mutasi_id', null)
        setValBarang(null)
        setValRackAsal(null)
        setValRackTujuan(null)
    }

    const defaultValues = {
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        watch,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const getData = () => {
        let url = apiUrl.apiUrl + '/gudang/racking/mutasi-list'
        axios
            .get(url, {
                params: {
                    tgl_awal: tglAwal,
                    tgl_akhir: tglAkhir,
                    mmgudang_id: mmgudangId
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                } else {

                }
            })
    }

    const getRack = () => {
        let url = apiUrl.apiUrl + '/gudang/racking/rack-list'
        axios
            .get(url, {
                params: {
                    mmgudang_id: mmgudangId
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListRack(data)
                } else {

                }
            })
    }

    const getBarang = () => {
        setLoading(false)
        const url = apiUrl.apiUrl + '/mm/barang/list-combo-by-gudang'
        axios
            .get(url, {
                params: { mmgudang_id: mmgudangId },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListBarang(data)
                    setLoading(true)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const handleDelete = (row: any) => {
        const url = apiUrl.apiUrl + '/gudang/racking/delete-rack/' + row.id
        axios
            .delete(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(response => {
                if (response.data.success) {
                    showToast(response.data.message, 'success');
                    getRack()
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    };

    const handleDeleteMutasi = (row: any) => {
        const url = apiUrl.apiUrl + '/gudang/racking/delete-mutasi/' + row.id
        axios
            .delete(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(response => {
                if (response.data.success) {
                    showToast(response.data.message, 'success');
                    getData()
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    };

    const ActionButtons = ({ row, onDelete }: {
        row: any;
        onDelete: (row: any) => void;
    }) => {
        const actions = [
            {
                title: "Lihat Detail",
                icon: "mdi:pencil",
                onClick: () => {
                    resetDetail();
                    setIsEditRack(true)
                    setValue('mmgudang_sub_id', row.id)
                    setValue('kode', row.kode)
                    setValue('nama', row.rack)
                    setOpenDialogRack(true)
                }
            },
            {
                title: "Hapus Rack",
                icon: "mdi:trash",
                onClick: () => onDelete(row)
            }
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const ActionButtonsMutasi = ({ row, onDelete }: {
        row: any;
        onDelete: (row: any) => void;
    }) => {
        const actions = [
            {
                title: "Lihat Detail",
                icon: "mdi:pencil",
                onClick: () => {
                    resetDetail();
                    setIsEditMutasi(true)
                    getBarang()
                    setValue('mmgudang_sub_mutasi_id', row.id)
                    setValue('mmbarang_id', row.barang_id)
                    setValBarang({ id: row.barang_id, nama: row.nama_barang })
                    setValRackAsal({ id: row.rack_asal_id, kode: row.kode_asal, rack: row.asal })
                    setValRackTujuan({ id: row.rack_tujuan_id, kode: row.kode_tujuan, rack: row.tujuan })
                    setValue('mmgudang_sub_asal_id', row.rack_asal_id)
                    setValue('mmgudang_sub_tujuan_id', row.rack_tujuan_id)
                    setValue('qty', row.qty)
                    setValue('keterangan', row.keterangan)
                    setOpenDialogMutasi(true)
                }
            },
            {
                title: "Hapus Rack",
                icon: "mdi:trash",
                onClick: () => onDelete(row)
            }
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={handleDelete}

                />
            ),
        },
    ];

    const actionDataMutasi = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtonsMutasi
                    row={row}
                    onDelete={handleDeleteMutasi}

                />
            ),
        },
    ];


    const handleChangeAutocompleteAsal = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmgudang_sub_asal_id', newValue ? newValue.id : null)
        setValRackAsal(newValue)
    }

    const handleChangeAutocompleteTujuan = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmgudang_sub_tujuan_id', newValue ? newValue.id : null)
        setValRackTujuan(newValue)
    }

    const handleChangeAutocompleteBarang = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmbarang_id', newValue ? newValue.id : null)
        setValBarang(newValue)
    }

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <TabContext value={tabs}>
                    <TabList
                        scrollButtons
                        variant='fullWidth'
                        onChange={handleChangeTabs}
                        aria-label='forced scroll tabs example'
                    >
                        <Tab value='0' label='Master Rack' icon={<Icon icon='mdi:warehouse' />} />
                        <Tab value='1' label='Mutasi' icon={<Icon icon='mdi:swap-horizontal' />} />
                    </TabList>
                    <TabPanel value='0'>
                        <Box
                            sx={{
                                mt: 2,
                                width: '100%',
                                display: 'flex',
                                flexWrap: 'wrap',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}
                        >
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            </Box>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>
                                <Fab color='primary' size='medium' onClick={() => {
                                    setIsEditRack(false)
                                    resetDetail()
                                    setOpenDialogRack(true)
                                }}>
                                    <Icon icon='mdi:plus' fontSize={35} color='white' />
                                </Fab>
                            </Box>
                        </Box>
                        <MsiDatagrid array={listRack} actions={actionData} />
                    </TabPanel>
                    <TabPanel value='1'>
                        <Box>
                            <Grid
                                container
                                sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                                spacing={5}
                            >
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth>
                                        <TextField
                                            label='Tanggal Awal'
                                            type='date'
                                            onChange={(e) => setTglAwal(e.target.value)}
                                            value={tglAwal}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth>

                                        <TextField
                                            label='Tanggal Akhir'
                                            type='date'
                                            onChange={(e) => setTglAkhir(e.target.value)}
                                            value={tglAkhir}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth>
                                        <Button
                                            variant='contained'
                                            sx={{ mt: 1 }}
                                            startIcon={<Icon icon='mdi:magnify' />}
                                            onClick={() => getData()}
                                        >
                                            Cari Data
                                        </Button>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Fab color='primary' size='medium' onClick={() => {
                                        resetDetail()
                                        getBarang()
                                        setIsEditMutasi(false);
                                        setOpenDialogMutasi(true)
                                    }}>
                                        <Icon icon='mdi:plus' fontSize={35} color='white' />
                                    </Fab>
                                </Grid>
                            </Grid>
                        </Box>
                        <MsiDatagrid array={listData} actions={actionDataMutasi} hiddenColumns={['barang_id', 'rack_asal_id', 'rack_tujuan_id', 'kode_asal', 'kode_tujuan']} />
                    </TabPanel>
                </TabContext>
            </Grid>
            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialogRack}
                onClose={() => setOpenDialogRack(false)}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit((data) => {
                    let url = '';
                    if (isEditRack) {
                        url = apiUrl.apiUrl + '/gudang/racking/edit-rack/' + data.mmgudang_sub_id;
                    } else {
                        url = apiUrl.apiUrl + '/gudang/racking/add-rack';
                    }

                    axios.post(url, {
                        id: isEditRack ? data.mmgudang_sub_id : mmgudangId,
                        mmgudang_id: mmgudangId,
                        kode: data.kode,
                        nama: data.nama,
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                        .then(response => {
                            if (response.data.success) {
                                showToast(response.data.message, 'success');
                                setOpenDialogRack(false);
                                getRack();
                            } else {
                                showToast(response.data.message, 'error');
                                setOpenDialogRack(false);
                            }
                        })
                        .catch(error => {
                            showToast(error.message, 'error');
                        });
                })}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                            Tambah Rack
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers sx={{ p: 2 }}>
                        <Grid container spacing={3}>
                            {isEditRack ?
                                <Grid item xs={12} md={12}>
                                    <FormControl fullWidth>
                                        <Controller
                                            name='mmgudang_sub_id'
                                            control={control}
                                            render={({ field: { value, onChange } }) => (
                                                <TextField
                                                    value={value}
                                                    label='ID Detail'
                                                    type='number'
                                                    InputLabelProps={{ shrink: true }}
                                                    onChange={onChange}
                                                    InputProps={{ readOnly: true }} // Make the input read-only
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Grid> : null}
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='kode'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Kode'
                                                type='text'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                            />
                                        )}
                                    />
                                </FormControl>
                                {errors.kode && (
                                    <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                )}
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='nama'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Nama'
                                                type='text'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                            />
                                        )}
                                    />
                                </FormControl>
                                {errors.nama && (
                                    <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                )}
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className='dialog-actions-dense'>
                        <Button variant='contained' type='submit'>Simpan</Button>
                        <Button onClick={() => setOpenDialogRack(false)}>Batal</Button>
                    </DialogActions>
                </form>
            </Dialog>
            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialogMutasi}
                onClose={() => setOpenDialogMutasi(false)}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit((data) => {
                    let url = "";
                    if (isEditMutasi) {
                        url = apiUrl.apiUrl + '/gudang/racking/edit-mutasi/' + data.mmgudang_sub_mutasi_id;
                    } else {
                        url = apiUrl.apiUrl + '/gudang/racking/add-mutasi';
                    }

                    axios.post(url, {
                        id: isEditMutasi ? data.mmgudang_sub_mutasi_id : mmgudangId,
                        mmgudang_id: mmgudangId,
                        mmgudang_sub_asal_id: data.mmgudang_sub_asal_id,
                        mmgudang_sub_tujuan_id: data.mmgudang_sub_tujuan_id,
                        mmbarang_id: data.mmbarang_id,
                        mmbarang_batch_id: data.mmbarang_batch_id,
                        keterangan: data.keterangan,
                        qty: data.qty,
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                        .then(response => {
                            if (response.data.success) {
                                showToast(response.data.message, 'success');
                                setOpenDialogMutasi(false);
                                getData();
                            } else {
                                showToast(response.data.message, 'error');
                                setOpenDialogMutasi(false);
                            }
                        })
                        .catch(error => {
                            showToast(error.message, 'error');
                        });
                })}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                            Tambah Mutasi
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers sx={{ p: 2 }}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valBarang}
                                        options={listBarang}
                                        id='barang'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        getOptionLabel={(option: any) => option.nama || ""}   // ✅ tampilkan nama
                                        onChange={handleChangeAutocompleteBarang}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Barang'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valRackAsal}
                                        options={listRack}
                                        id='rack_asal'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        getOptionLabel={(option: any) => option.rack || ""}   // ✅ tampilkan nama
                                        onChange={handleChangeAutocompleteAsal}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.rack}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Rack Asal'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valRackTujuan}
                                        options={listRack}
                                        id='rack_tujuan'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        getOptionLabel={(option: any) => option.rack || ""}   // ✅ tampilkan nama
                                        onChange={handleChangeAutocompleteTujuan}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.rack}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Rack Tujuan'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='qty'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Quantity'
                                                type='number'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                            />
                                        )}
                                    />
                                </FormControl>
                                {errors.qty && (
                                    <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                )}
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Keterangan'
                                                rows={3}
                                                multiline
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                            />
                                        )}
                                    />
                                </FormControl>
                                {errors.keterangan && (
                                    <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                )}
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className='dialog-actions-dense'>
                        <Button variant='contained' type='submit'>Simpan</Button>
                        <Button onClick={() => setOpenDialogMutasi(false)}>Batal</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </Grid>
    )
}
